import { useRef, useState } from "react"
import { useSearchParams, useLocation } from "react-router-dom"
import { SectionHeading, TableCustom, WrapperAdvancedSearch, FooterButtonVolver } from "../../components/common"
import { useManagedContext } from "../../components/hooks"
import { usePermissions } from "../../components/hooks/usePermissions"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import { APIS } from "../../config/apis"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { ServerRequest } from "../../utils/apiweb"
import CategoriaVehiculoModal from "../../components/controls/CategoriaVehiculoModal"
import { PERMISSIONS } from "../../consts/permissions"

const CategoriasVehiculosView = () => {
    const [searchParams] = useSearchParams();
    const isViewOnly = searchParams.get('mode') === 'view';
    const location = useLocation()
    const previousFilters = location.state?.filters

    const { setIsLoading, showMessageModal } = useManagedContext()

    const [categorias, setCategorias] = useState()
    const [editItem, setEditItem] = useState()
    const [editMode, setEditMode] = useState()
    const [tableVisible, setTableVisible] = useState(false)

    const searchRef = useRef()
    
    const { hasPermission } = usePermissions();
    const canEdit = hasPermission(PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT);
    const allowEditActions = canEdit && !isViewOnly;

    const filterData = data => {
        const { codigo, nombre, codigoSucerp } = searchRef.current.filters

        let filtered = [...data]

        if (codigo !== '') filtered = filtered.filter(rubro => rubro.codigo.toLowerCase().includes(codigo.toLowerCase()))
        if (nombre !== '') filtered = filtered.filter(rubro => rubro.nombre.toLowerCase().includes(nombre.toLowerCase()))
        if (codigoSucerp !== '') filtered = filtered.filter(rubro => rubro.codigoSucerp.toLowerCase().includes(codigoSucerp.toLowerCase()))

        return filtered
    }

    const SearchCategorias = () => {
        setIsLoading(true)

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CATEGORIA_VEHICULO,
            null,
            null,
            res => res.json().then(data => {
                setCategorias(filterData(data))
                setIsLoading(false)
                setTableVisible(true)
                setEditMode(null)
                setEditItem(null)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
        )
    }

    const confirmRemoveId = id => {
        setIsLoading(true)
        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.CATEGORIA_VEHICULO,
            `/${id}`,
            null,
            () => {
                ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "La categoría fue dada de baja correctamente")
                SearchCategorias()
            },
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const avmr = {
        onAdd: () => {
            setEditMode('add')
            setEditItem({
                id: -Date.now(),
                codigo: '',
                nombre: '',
                codigoSucerp: '',
            })
        },
        onView: (item) => {
            setEditMode('view')
            setEditItem(item)
        },
        onModify: (item) => {
            setEditMode('modify')
            setEditItem(item)
        },
        onRemove: ({ id }) => {
            showMessageModal({
                title: "Confirmación",
                message: "¿Está seguro de borrar el registro?",
                onConfirm: () => confirmRemoveId(id),
            })
        }
    }

    const onModalConfirm = () => {
        if (tableVisible) SearchCategorias()
        setEditMode(null)
        setEditItem(null)
    }

    const onModalCancel = () =>{
        setEditMode(null)
        setEditItem(null)
    }

    return <>
        <SectionHeading titles={[{ title: 'Entidades' }, { title: 'Administración de listas', url: '/entidades' }, { title: 'Categorías de vehículos' }]}
                        onAddClick={allowEditActions ? avmr.onAdd : null} tableVisible={tableVisible} />

        <section className='section-accordion'>
            <WrapperAdvancedSearch
                ref={searchRef}
                filters={[
                    { title: 'Código', field: 'codigo', type: 'string', size: 2 },
                    { title: 'Nombre', field: 'nombre', type: 'string', size: 4 },
                    { title: 'Código Suats', field: 'codigoSucerp', type: 'string', size: 2 },
                ]}
                onSearch={SearchCategorias}
            />

            {tableVisible && (
                <TableCustom
                    className={'TableCustomBase m-top-20'}
                    data={categorias}
                    avmr={avmr}
                    editCode={allowEditActions ? PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT : null}
                    disabled={!allowEditActions}
                    messageEmpty="No se encontraron resultados"
                    columns={[
                        { Header: 'Código', accessor: 'codigo', width: '30%', },
                        { Header: 'Nombre', accessor: 'nombre', width: '30%', },
                        { Header: 'Código Suats', accessor: 'codigoSucerp', width: '30%', },
                    ]}
                />
            )}

            {editItem && (
                <CategoriaVehiculoModal
                    {...{ editMode, editItem }}
                    onConfirm={onModalConfirm}
                    onCancel={onModalCancel}
                />
            )}
        </section>
        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <FooterButtonVolver filters={previousFilters} to="/entidades" />
            </div>
        </footer>
    </>
}

export default CategoriasVehiculosView
